jQuery( document ).ready(function() {

    if($('.listmultisocieteasiatique_cards').length > 0) {
  
      jQuery( document ).ready(function() {

        if($('.listmultisocieteasiatique_cards').length > 0) {
      
          $(".listmultisocieteasiatique_card").slice(0, 10).show();
    
          $(".listmultisocieteasiatique_showmore").on('click', function(e) {
            e.preventDefault();
    
            $(".listmultisocieteasiatique_card:hidden").slice(0, 5).slideDown();
            if ($(".listmultisocieteasiatique_card:hidden").length == 0) {
              $(".listmultisocieteasiatique_showmore").fadeOut('slow');
            }
          });
      
        }
      
      });
  
    }
  
  });